var _linearGradient, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcGlp24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "objectBoundingBox",
    x1: 0.5,
    x2: 0.435,
    y1: -0.1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0ac3ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d42fc"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v23.833h-24z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-208.168-2916.3a11.931 11.931 0 0 1 -9.923 11.743 12.924 12.924 0 0 1 -2.022.167 11.847 11.847 0 0 1 -10.59-6.514l-.186-.353h3.121l.079.107a9.214 9.214 0 0 0 9.128 3.885 9.2 9.2 0 0 0 7.616-9.781l-5.575-.01 1.629 4.6-1.992 2.737-3.573-10.134 11.758.02.049.177a10.559 10.559 0 0 1 .314 1.364 11.435 11.435 0 0 1 .167 1.992z",
    transform: "translate(232.001 2928.389)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-209.31-2921.55h-3.141l-.079-.108a9.2 9.2 0 0 0 -9.118-3.875 9.209 9.209 0 0 0 -7.626 9.771l5.594.01-1.629-4.6 2-2.737 3.563 10.134-8.981-.009h-2.787l-.049-.177a10.6 10.6 0 0 1 -.294-1.344 11.91 11.91 0 0 1 9.756-13.725 11.875 11.875 0 0 1 12.6 6.308z",
    transform: "translate(232.024 2928.55)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGlp24);
export default __webpack_public_path__ + "static/media/ic_glp_24.eff381d992b0a79d72e64230b528167a.svg";
export { ForwardRef as ReactComponent };